import { Link, useSearchParams } from "react-router-dom";
import { AeonyxWordmark } from "@/components/aeonyx/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function Success() {
  const [params] = useSearchParams();
  const paymentId = params.get("payment_id");
  const orderId = params.get("order_id");

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 py-6">
        <Link to="/" aria-label="Aeonyx Life Sciences — Home">
          <AeonyxWordmark className="h-[52px] w-auto" priority />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div
          className="max-w-lg w-full rounded-3xl border border-slate-200 bg-white p-10 shadow-[0_30px_80px_rgba(2,6,23,0.06)]"
          data-testid="success-card"
        >
          <div className="text-center">
            <CheckCircle2 className="h-12 w-12 mx-auto text-emerald-500" />
            <h1 className="font-display mt-6 text-3xl text-slate-900 font-light">
              Order confirmed
            </h1>
            <p className="mt-3 text-slate-600">
              Thank you. Your CryoVault is reserved and a confirmation is on
              its way to your email.
            </p>

            {(paymentId || orderId) && (
              <div className="mt-6 rounded-2xl bg-slate-50 border border-slate-200 p-4 text-left text-sm space-y-1.5">
                {orderId && (
                  <div className="flex justify-between text-slate-700">
                    <span>Order ID</span>
                    <span className="font-mono tabular-nums text-xs">{orderId}</span>
                  </div>
                )}
                {paymentId && (
                  <div className="flex justify-between text-slate-700">
                    <span>Payment ID</span>
                    <span className="font-mono tabular-nums text-xs">{paymentId}</span>
                  </div>
                )}
              </div>
            )}

            <Link to="/">
              <Button
                data-testid="success-home-button"
                className="mt-8 h-12 px-6 rounded-full bg-slate-900 hover:bg-slate-800 text-white"
              >
                Back to home
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
